// extracted by mini-css-extract-plugin
export var saLogosGalleryContainer = "saLogosGallery-module--saLogosGalleryContainer--3g3rK";
export var saLogosGallerySectionTitle = "saLogosGallery-module--saLogosGallerySectionTitle--2LHqp";
export var saLogosGalleryList = "saLogosGallery-module--saLogosGalleryList--3YV5N";
export var saLogosGalleryItem = "saLogosGallery-module--saLogosGalleryItem--3nPt9";